(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
    Velune (layout novo), nas páginas de coleção e de busca:
    1. Ordenar: a caixa de escolha recarrega a lista na ordem pedida, mantendo os filtros.
    2. "Load more": busca a página seguinte desta seção e põe os produtos embaixo dos que já estão na
       tela; o endereço ganha ?page=N. O botão some na última página. Se a busca falhar, o botão funciona
       como o link comum que ele é (leva à página seguinte). O carregamento automático do Horizon ao
       rolar fica desligado (o marcador dele é escondido em assets/velune-mm-collection.css).
  */
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-mm-sort]')) return;

    const next = new URL(window.location.href);
    next.searchParams.set('sort_by', select.value);
    next.searchParams.delete('page');
    next.hash = '';
    window.location.assign(next.toString());
  });

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-mm-more]');
    if (!(button instanceof HTMLAnchorElement)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; // abrir em outra aba

    const list = button.closest('results-list');
    const grid = list?.querySelector('[ref="grid"]');
    const sectionId = list?.getAttribute('section-id');
    if (!grid || !sectionId) return; // sem a lista, o link leva à página seguinte

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    const pageUrl = new URL(button.href, window.location.href);

    try {
      const sectionUrl = new URL(pageUrl);
      sectionUrl.searchParams.set('section_id', sectionId);

      const response = await fetch(sectionUrl.toString());
      if (!response.ok) throw new Error(String(response.status));

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = html.querySelectorAll('[ref="grid"] > [ref="cards[]"]');
      if (!cards.length) throw new Error('empty');

      grid.append(...Array.from(cards).map((card) => document.importNode(card, true)));

      const following = html.querySelector('[data-mm-more]');
      if (following instanceof HTMLAnchorElement && following.getAttribute('href')) {
        button.setAttribute('href', following.getAttribute('href') || '');
      } else {
        button.closest('.mm-plp-more')?.setAttribute('hidden', '');
      }

      // O endereço acompanha a página carregada, sem criar um passo a mais no botão de voltar
      const current = new URL(window.location.href);
      current.searchParams.set('page', pageUrl.searchParams.get('page') || '');
      history.replaceState(history.state, '', current.toString());
      button.removeAttribute('aria-busy');
    } catch {
      window.location.assign(pageUrl.toString());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  /* O mesmo script de sections/main-collection.liquid (as duas seções nunca aparecem na mesma página). */
  /*
    Velune (layout novo), nas páginas de coleção e de busca:
    1. Ordenar: a caixa de escolha recarrega a lista na ordem pedida, mantendo os filtros.
    2. "Load more": busca a página seguinte desta seção e põe os produtos embaixo dos que já estão na
       tela; o endereço ganha ?page=N. O botão some na última página. Se a busca falhar, o botão funciona
       como o link comum que ele é (leva à página seguinte). O carregamento automático do Horizon ao
       rolar fica desligado (o marcador dele é escondido em assets/velune-mm-collection.css).
  */
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-mm-sort]')) return;

    const next = new URL(window.location.href);
    next.searchParams.set('sort_by', select.value);
    next.searchParams.delete('page');
    next.hash = '';
    window.location.assign(next.toString());
  });

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-mm-more]');
    if (!(button instanceof HTMLAnchorElement)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; // abrir em outra aba

    const list = button.closest('results-list');
    const grid = list?.querySelector('[ref="grid"]');
    const sectionId = list?.getAttribute('section-id');
    if (!grid || !sectionId) return; // sem a lista, o link leva à página seguinte

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    const pageUrl = new URL(button.href, window.location.href);

    try {
      const sectionUrl = new URL(pageUrl);
      sectionUrl.searchParams.set('section_id', sectionId);

      const response = await fetch(sectionUrl.toString());
      if (!response.ok) throw new Error(String(response.status));

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = html.querySelectorAll('[ref="grid"] > [ref="cards[]"]');
      if (!cards.length) throw new Error('empty');

      grid.append(...Array.from(cards).map((card) => document.importNode(card, true)));

      const following = html.querySelector('[data-mm-more]');
      if (following instanceof HTMLAnchorElement && following.getAttribute('href')) {
        button.setAttribute('href', following.getAttribute('href') || '');
      } else {
        button.closest('.mm-plp-more')?.setAttribute('hidden', '');
      }

      // O endereço acompanha a página carregada, sem criar um passo a mais no botão de voltar
      const current = new URL(window.location.href);
      current.searchParams.set('page', pageUrl.searchParams.get('page') || '');
      history.replaceState(history.state, '', current.toString());
      button.removeAttribute('aria-busy');
    } catch {
      window.location.assign(pageUrl.toString());
    }
  });

  } catch(e) { console.error(e); }
})();
})();
